<template>
    <div>
        <vue-echarts :option="option" ref="chart" class="chart" autoResize />
    </div>
</template>

<script>
import { VueEcharts } from "vue3-echarts";
// import { computed, onMounted } from 'vue';

export default {
    name: 'pieChart',
    data() {
        return {
        }
    },
    props: {
        probTracking: Object
    },
    methods: {
        globalNumDecFixed(num, dec_amount) {
            var new_num = Number(num);
            if (!(num % 1)) {
                dec_amount = 0;
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: dec_amount,
            }).format(new_num.toFixed(dec_amount));
        },
    },
    components: {
        VueEcharts,
    },
    mounted() {
        setTimeout(function () {
            this.$nextTick(() => {
                this.$refs.chart.setOption(this.option);
            })
        }.bind(this), 350)
    },
    computed: {
        option() {
            return {
                textStyle: {
                    fontFamily: 'kanit',
                    fontWeight: 'normal'
                },
                color: ['#adb95d', '#f4c730', '#e2e8f0'],
                tooltip: {
                    trigger: 'item',
                    confine: 'true',
                    textStyle: {
                        fontFamily: 'kanit',
                        fontWeight: '400',
                        color: '#1d4481'
                    },
                    backgroundColor: '#f3f6f9',
                    borderColor: 'none',
                    valueFormatter: (value) => this.globalNumDecFixed(value) + ' คน'
                },
                legend: {
                    show: false,
                    orient: 'vertical',
                    left: 'left',
                    top: 'center',
                    icon: 'circle',
                    textStyle: {
                        color: '#728196'
                    },
                },
                series: [
                    {
                        name: {
                            show: false
                        },
                        type: 'pie',
                        radius: '90%',
                        center: ['50%', '50%'],
                        data: [
                            { value: this.probTracking.helped, name: 'ช่วยเหลือแล้ว' },
                            { value: this.probTracking.in_process, name: 'อยู่ระหว่างการช่วยเหลือ' },
                            { value: this.probTracking.not_proceeded, name: 'ยังไม่ได้ดำเนินการ' }
                        ],
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 5
                        },
                        label: {
                            show: false
                        },
                        emphasis: {
                            show: false,
                        }
                    }
                ]
            }
        },
    },
};
</script>

<style scoped>
.chart {
    top: 0px;
    max-height: 250px;
    height: 250px;
}

@media screen and (max-width: 1199.8px) {
    .chart {
        max-height: 230px;
        height: 230px;
    }
}
</style>